module.exports = __webpack_public_path__ + "img/379.e3eb0faa.jpg";